var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.rowValue != 0)?_c('el-tag',{class:_vm.ClassObject,staticStyle:{"cursor":"pointer"},attrs:{"plain":""},on:{"click":function($event){return _vm.onClicked(_vm.column, _vm.row)}}},[_vm._v(" "+_vm._s(_vm.Amount)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }